<template>
  <article class="sale-manage-brands">
    <header class="title-bar zz-title-bar">
      <h2>选择品牌</h2>
    </header>
    <ul class="letter-list">
      <li v-for="key in typeList" :key="key" :class="{on: key === keyVal}">
        <a href="javascript:void(0);" @click.stop="selBrand(key)">
          <i class="icon_hot" v-if="key === 'HOT'"></i>
          {{ key }}
        </a>
      </li>
    </ul>
    <ul class="car-list">
      <li v-for="brand in brandByID" @click.stop="selSeries(brand.id)" :key='brand.id'>
        <a href="javascript:void(0);">
          <img :src="brand.image_url" alt="" width="35" height="35" class="">
          <span>{{brand.name}}</span>
        </a>
      </li>
    </ul>
  </article>
</template>
<script>
import cache from '../../../common/cache'

export default {
  data () {
    return {
      sessionKey: 'saleManageBrands',
      onClass: true,
      brands: {},
      brandByID: [],
      typeList: [],
      keyVal: 'HOT',
      from: '',
      manual: ''
    }
  },
  created () {
    let brands = cache.getSessionData(this.sessionKey)
    if (brands) {
      this.brands = brands
      this.setTypeList(this.brands)
      this.brandByID = this.brands.HOT
    } else {
      this.$rest.saleManage.getCarBrandList().then((res) => {
        if (res.code === 0) {
          this.brands = res.brands
          this.setTypeList(this.brands)
          cache.setSessionData(this.sessionKey, this.brands)
          this.brandByID = this.brands.HOT
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  methods: {
    setTypeList(brands) {
      let typeList = Object.keys(brands)
      typeList.forEach((v, i, a) => {
        if (v === 'HOT') { // 保证HOT在第一位
          a.splice(i, 1)
          a.unshift(v)
        }
      })
      this.typeList = typeList
    },
    selBrand (v) {
      this.brandByID = this.brands[v]
      this.keyVal = v
    },
    selSeries (brandId) {
      this.$router.push({
        path: '/salemanage/car/series/' + brandId
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
  .car-tip-title {
    line-height: 22px;
    color: #666;
    padding-left: 10px;
    margin-top: 15px;
  }

  .car-style-add {
    padding: 0 0 30px 0;
    margin-top: -14px;
    input {
      background: #fff;
      padding: 10px;
      box-sizing: border-box;
    }
    .plr {
      padding: 0 30px;
    }
    .btn {
      border-radius: 0;
      height: 44px;
      line-height: 44px;
      font-size: 15px;
    }
    .weui_cell {
      padding: 15px 10px;
    }
  }
  .sale-manage-brands .letter-list .icon_hot {
    width: 60/@w2;
    height: 60/@w2;
    display: block;
    background: url(../../../stylesheets/images/ico_hot.png) no-repeat;
    background-size: 100%;
    background-position: 0 2/@w2;
  }
  .sale-manage-brands .letter-list li.on .icon_hot {
    background-position: 0 -60/@w2;
  }

  @import "../../../stylesheets/modules/manage/input.less";
</style>
